import { Injectable, signal, WritableSignal } from '@angular/core';

export interface SidebarLink {
  label: string;
  route?: string;
  action?: () => void;
  iconPath?: string;
  variant?: 'filled' | 'outlined' | 'plain' | 'db-link' | undefined;
  customClass?: string;
}

@Injectable({
  providedIn: 'root'
})
export class Sidebar {
  links: WritableSignal<SidebarLink[]> = signal<SidebarLink[]>([]);
  isMobileSidebarOpen: WritableSignal<boolean> = signal(false); 
  defaultLinks: SidebarLink[] = [
    { label: 'SIDEBAR.ACCOUNTS', route: '/accounts', iconPath: 'assets/icons/accounts.svg', variant: 'db-link' },
    { label: 'SIDEBAR.CARDS', route: '/cards', iconPath: 'assets/icons/cards.svg', variant: 'db-link' },
    { label: 'SIDEBAR.TRANSACTIONS', route: '/transactions', iconPath: 'assets/icons/transactions.svg', variant: 'db-link' },
    { label: 'SIDEBAR.ACTIVITY_STATUS', route: '/activity-status', iconPath: 'assets/icons/activity-status.svg', variant: 'db-link' },
    { label: 'SIDEBAR.USER_MANAGEMENT', route: '/user-management', iconPath: 'assets/icons/user-management.svg', variant: 'db-link' },
  ];


  setLinks(links: SidebarLink[]) {
    this.links.set(links);
  }

  addLink(link: SidebarLink) {
    this.links.update(current => [...current, link]);
  }

  removeLink(label: string) {
    this.links.update(current => current.filter(l => l.label !== label));
  }

  setToDefault() {
    this.links.set(this.defaultLinks);
  }

  toggleSidebar() {
    this.isMobileSidebarOpen.update(v => !v);
  }
}
